module.exports = __webpack_public_path__ + "static/media/21.59d99b74.jpg";